module.exports = "/_next/static/images/careersPhoto-2x-fa7cb0ec2b83ad930483ed672f9c43b5.jpg.webp";